import api from './api'

export interface SiteBranding {
  system_name: string
  icp_record: string | null
  user_agreement_md: string | null
  privacy_policy_md: string | null
  product_intro_md: string | null
}

export const siteBrandingApi = {
  getSiteBranding: () => api.get<SiteBranding>('/site-branding'),
}
